/**
 * Build-time switches for eligibility v2. Both are baked in by Vite from `StageConfig`
 * (`ffsEligibilityV2Enabled`, `ffsCoverageDiscoveryEnabled`) through service.manifest.json's
 * `stageConfig` source, so they are 'true' or 'false' in every released bundle. Anything but the
 * literal 'true', including unset, is off.
 */
export interface FeatureFlags {
  /** Serves the v2 flow at `/eligibility`; off, `/eligibility` is the v1 flow. */
  readonly eligibilityV2: boolean;
  /** Offers "I'm not sure — look it up for me". Never on without `eligibilityV2`. */
  readonly coverageDiscovery: boolean;
}

export interface FeatureFlagEnv {
  readonly VITE_FFS_ELIGIBILITY_V2_ENABLED?: string | undefined;
  readonly VITE_FFS_COVERAGE_DISCOVERY_ENABLED?: string | undefined;
}

export function readFeatureFlags(env: FeatureFlagEnv): FeatureFlags {
  const eligibilityV2 = env.VITE_FFS_ELIGIBILITY_V2_ENABLED === 'true';
  return {
    eligibilityV2,
    coverageDiscovery: eligibilityV2 && env.VITE_FFS_COVERAGE_DISCOVERY_ENABLED === 'true',
  };
}

/** Static `import.meta.env.NAME` reads: Vite substitutes only that form at build time. */
export function featureFlagsFromBuild(): FeatureFlags {
  return readFeatureFlags({
    VITE_FFS_ELIGIBILITY_V2_ENABLED: import.meta.env.VITE_FFS_ELIGIBILITY_V2_ENABLED,
    VITE_FFS_COVERAGE_DISCOVERY_ENABLED: import.meta.env.VITE_FFS_COVERAGE_DISCOVERY_ENABLED,
  });
}
